import React from "react";
import ZIcon, { Icons } from "../ZIcon";
import ZModal from "../ZModal";
import { ZConfirmProps } from "./interface";

const ZModalConfirm = ({ title, content, onOk }: ZConfirmProps) => {
	return ZModal.confirm({
		title: title ?? "You have unsaved changes!",
		icon: (
			<span className="anticon anticon-question-circle">
				<ZIcon
					name={Icons.WARNINGCIRCLE}
					color="gold"
					colorVariant={6}
				/>
			</span>
		),
		content: content,
		okText: "Yes",
		cancelText: "Cancel",
		onOk: () => {
			onOk?.();
		}
	});
};

export default ZModalConfirm;
